import React, { Component } from 'react'
import {pure} from 'recompose'

import { Grid, Row, Col } from 'react-flexbox-grid'

import { defaultWorkingHours, defaultWorkingDays, formStates } from 'const'

import WorkingHours from 'components/WorkingHours'
import Button, {icons} from 'components/Button'
import Lessons from 'components/Lessons'
import ProductPackages from 'components/ProductPackages'
import GroupLessons from 'components/GroupLessons'
import BasicInfo from 'components/BasicInfo';
import Website from 'components/Website';


const saveProfile = (event, handler) => {
  event.preventDefault()
  handler()
}

class ProfileForm extends Component {

    onAvailabilityChange = (payload) => {
      // merge the incoming change with props
      const { day, time, active } = payload
      const { workingHours, workingDays } = this.props
      const { onChange } = this.props
      
      const wh = { ...workingHours, days: { ...workingHours.days, [day]: time } }
      const wd = { ...workingDays, [day]: active }
      
      
      onChange([
        {
          target: {
            name: 'workingHours',
            value: wh,
          }
        },
        {
          target: {
            name: 'workingDays',
            value: wd,
          }
        }
      ])
    }

    onLessonChange = (payload) => {
      const {onLessonChange } = this.props
      onLessonChange(payload)
    }

    onPackageChange = (payload) => {
      const {onPackageChange } = this.props
      onPackageChange(payload)
    }

    onImageUpload = (payload) => {
      const { onChange } = this.props
      onChange({
        target: {
          name: 'profileImage',
          value: payload,
        }
      })
    }
    
    
    
    render() {
        if(!this.props.id){
            return null
        }
        const {
          id,
          firstName = '',
          lastName = '',
          bio = '',
          yearsPlayed = '',
          handicap = '',
          holeInOnes = '',
          phone = '',
          gmail = '',
          workingHours = defaultWorkingHours,
          workingDays = defaultWorkingDays,
          lessons = [],
          loading,
          saving, 
          onSubmit, 
          onChange,
          toggleLesson,
          addPriceGroup,
          removePriceGroup,
          addCustomLesson,
          profileImage = undefined,
          packages = [],
          togglePackage,
          addCustomPackage,
          groupLesson,
          groupLessonOptions = [],
          gender = undefined,
          defaultImage,
          formState = formStates.PROFILE,
          changeFormState,
          techContactName = '',
          techContactPhone = '',
          techContactEmail = '',
          websiteURL = '',
         } = this.props

         


        const enabledLessonTypes = lessons.filter(lesson => lesson.enabled).map(lesson => (lesson.type))

        if(loading){
            return (
                <Grid fluid>
                    <Row>
                      <Col xs={12}>
                          <p>Loading</p>
                      </Col>
                  </Row>
                </Grid>
            )
        }
        return (
          <div className="profile-form">
            {(() => {
              switch(formState){
                case formStates.PROFILE:
                default: {
                  return (
                    <form onSubmit={event => {
                        event.preventDefault()
                        changeFormState(event, formStates.HOURS)
                      }}>
                      <BasicInfo 
                        id={id}
                        firstName={firstName}
                        lastName={lastName}
                        bio={bio}
                        yearsPlayed={yearsPlayed}
                        handicap={handicap}
                        holeInOnes={holeInOnes}
                        profileImage={profileImage}
                        onImageUpload={this.onImageUpload}
                        defaultImage={defaultImage}
                        gender={gender}
                        phone={phone}
                        gmail={gmail}
                        onChange={onChange}>
                        <Row className="form--row form-row--submit">
                        <Col mdOffset={3} xs={12} md={6}>
                          <div className="form-group">
                            <Button
                              className="text--uppercase button__wide"
                              type="submit">
                              Next
                            </Button>
                          </div>
                        </Col>
                      </Row>
                      </BasicInfo>
                    </form>
                  )
                }
                case formStates.HOURS:{
                  return (
                    <form onSubmit={event => {
                        event.preventDefault()
                        changeFormState(event, formStates.LESSONS)
                      }}>
                      <WorkingHours 
                        times={workingHours}
                        days={workingDays}
                        onChange={this.onAvailabilityChange}>
                        <Row className="form--row form-row--submit">
                          <Col xs={6}>
                            <div className="form-group">
                              <Button
                                icon={icons.ARROW_LEFT}
                                prependIcon={true}
                                className="text--uppercase button__wide"
                                type="button"
                                buttonType="secondary"
                                onClick={event => {event.preventDefault(); changeFormState(event, formStates.PROFILE)}}
                              >
                                Previous
                              </Button>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <Button
                                className="text--uppercase button__wide"
                                type="submit">
                                Next
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </WorkingHours>
                    </form>
                  )
                }
                case formStates.LESSONS:{
                  return (
                    <form onSubmit={event => {
                      event.preventDefault()
                      changeFormState(event, formStates.PACKAGES)
                    }}>
                      <Lessons
                        lessons={lessons}
                        toggleLesson={toggleLesson}
                        addPriceGroup={addPriceGroup}
                        removePriceGroup={removePriceGroup}
                        onChange={this.onLessonChange}
                        addCustomLesson={addCustomLesson}>
                        <Row className="form--row form-row--submit">
                          <Col xs={6}>
                            <div className="form-group">
                              <Button
                                icon={icons.ARROW_LEFT}
                                prependIcon={true}
                                className="text--uppercase button__wide"
                                type="button"
                                buttonType="secondary"
                                onClick={event => {event.preventDefault(); changeFormState(event, formStates.HOURS)}}
                              >
                                Previous
                              </Button>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <Button
                                className="text--uppercase button__wide"
                                type="submit">
                                Next
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </Lessons>
                    </form>
                  )
                }
                case formStates.PACKAGES:{
                  return (
                    <form onSubmit={event => {
                      event.preventDefault()
                      changeFormState(event, formStates.GROUPS)
                    }}>
                      <ProductPackages
                        packages={packages}
                        togglePackage={togglePackage}
                        onChange={this.onPackageChange}
                        addCustomPackage={addCustomPackage}
                        enabledLessonTypes={enabledLessonTypes}>
                        <Row className="form--row form-row--submit">
                          <Col xs={6}>
                            <div className="form-group">
                              <Button
                                icon={icons.ARROW_LEFT}
                                prependIcon={true}
                                className="text--uppercase button__wide"
                                type="button"
                                buttonType="secondary"
                                onClick={event => {event.preventDefault(); changeFormState(event, formStates.LESSONS)}}
                              >
                                Previous
                              </Button>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <Button
                                className="text--uppercase button__wide"
                                type="submit">
                                Next
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </ProductPackages>
                    </form>
                  )
                }
                case formStates.GROUPS:{
                  return (
                    <form onSubmit={event => {
                      event.preventDefault()
                      changeFormState(event, formStates.WEBSITE)
                    }}>
                      <GroupLessons
                        value={groupLesson}
                        options={groupLessonOptions}
                        onChange={onChange}
                      >
                        <Row className="form--row form-row--submit">
                          <Col xs={6}>
                            <div className="form-group">
                              <Button
                                icon={icons.ARROW_LEFT}
                                prependIcon={true}
                                className="text--uppercase button__wide"
                                type="button"
                                buttonType="secondary"
                                onClick={event => {event.preventDefault(); changeFormState(event, formStates.PACKAGES)}}
                              >
                                Previous
                              </Button>
                            </div>
                          </Col>
                          <Col xs={6}>
                            <div className="form-group">
                              <Button
                                className="text--uppercase button__wide"
                                type="submit">
                                Next
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </GroupLessons>
                    </form>
                  )
                }
                case formStates.WEBSITE:{
                  return (
                    <Website
                        techContactName={techContactName}
                        techContactPhone={techContactPhone}
                        techContactEmail={techContactEmail}
                        websiteURL={websiteURL}
                        onChange={onChange}>
                      <Row className="form--row form-row--submit">
                        <Col xs={6}>
                          <div className="form-group">
                            <Button
                              icon={icons.ARROW_LEFT}
                              prependIcon={true}
                              className="text--uppercase button__wide"
                              type="button"
                              buttonType="secondary"
                              onClick={event => {event.preventDefault(); changeFormState(event, formStates.GROUPS)}}
                            >
                              Previous
                            </Button>
                          </div>
                        </Col>
                        <Col xs={6}>
                          <div className="form-group">
                            <Button
                              saving={saving}
                              className="text--uppercase button__wide"
                              type="submit"
                              onClick={event => saveProfile(event, onSubmit)}>
                              Save and send
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Website>
                  )
                }
              }
            })()}
          </div>
        )
    }
}


export default pure(ProfileForm)



// WEBPACK FOOTER //
// ./src/components/ProfileForm/ProfileForm.js